import { lazy } from "react";
import { Mail } from "lucide-react";
import type { AreaRoutes } from "./types";

const Campaigns = lazy(() => import("../pages/Campaigns"));

export const campaigns: AreaRoutes = {
  routes: [{ path: "/campaigns", element: <Campaigns /> }],
  nav: [{ to: "/campaigns", label: "Campaigns", icon: Mail }],
};
